<template>
  <div id="group_modal" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-margin-auto-vertical">
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h2 class="uk-modal-title">{{ $t('general.choose_group') }}</h2>
      </div>
      <div class="uk-modal-body">
        <default-loading v-if="loading" />
        <template v-else>
          <table class="uk-table uk-table-middle uk-table-divider" v-if="groupList && groupList.length > 0">
            <thead>
              <tr>
                <th>{{ $t('general.group_name') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(group, index) in activeGroups" :key="index">
                <td>{{ group.name }}</td>
                <td class="text-right">
                  <button @click="selectGroup(group.id)" class="uk-button uk-button-default" type="button">
                    {{ $t('menu.company_dashboard.create_assignment') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="uk-alert-warning" uk-alert v-else>
            <p>{{ $t('general.no_groups_available') || 'Atama yapılabilecek kayıt bulunmuyor.' }}</p>
          </div>
        </template>
      </div>
      <div class="uk-modal-footer d-flex justify-content-end">
        <a href="javascript:;" class="btn btn-danger uk-modal-close">
          {{ $t("general.close") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultLoading from "@/view/components/loading/DefaultLoading";

export default {
  name: "UserGroupModal",
  components: {
    DefaultLoading
  },
  props: {
    groups: {
      type: [Array, Object],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    groupList() {
      if (!this.groups) return [];
      // API array veya object döndürebilir
      if (Array.isArray(this.groups)) {
        return this.groups;
      }
      // Object ise data property'sini kontrol et
      if (this.groups.data && Array.isArray(this.groups.data)) {
        return this.groups.data;
      }
      return [];
    },
    activeGroups() {
      return this.groupList.filter(group => group.status);
    }
  },
  methods: {
    selectGroup(groupId) {
      this.$emit('group-selected', groupId);
    },
    show() {
      UIkit.modal("#group_modal").show();
    },
    hide() {
      UIkit.modal("#group_modal").hide();
    }
  }
};
</script>

<style scoped>
.uk-modal-dialog {
  max-width: 600px;
}

.uk-modal-body {
  max-height: 500px;
  overflow-y: auto;
}

.uk-table {
  margin-bottom: 0;
}

.uk-button-default {
  transition: all 0.3s ease;
}

.uk-button-default:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
}
</style>

